module.exports = __webpack_public_path__ + "static/key-nextuphero-55c92eabe40352bd1d39e0cdccc907d5.webp";